import { Add } from '@mui/icons-material'
import { Box, Chip, Typography, useTheme } from '@mui/material'
import CustomButton from 'components/Fileds/CustomButton'
import CustomTypography from 'components/Fileds/CustomTypography'
import AddOnsView from 'components/Modal/AddOnsDialog/AddOnsView'
import CommonDataGrid from 'components/TableListing/CommonTable'
import React, { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { currencySymbol, servePanelStatusList } from 'utils/constant'

const isMiscItem = (row) => !!(row?.isMiscellaneous)

const OrderItemsComponent = ({ orderDetails, isViewOnly = false }) => {
    const userData = useSelector((state) => state?.posData);
    const navigate = useNavigate();
    const theme = useTheme();
    const [addonsModalOpen, setAddonsModalOpen] = useState(false);
    const [selectedItemAddons, setSelectedItemAddons] = useState([]);
    const [selectedOrderItem, setSelectedOrderItem] = useState([]);
    const openAddonsModal = (row) => {
        setSelectedItemAddons(row.orderItemAddons || []);
        setSelectedOrderItem(row || []);
        setAddonsModalOpen(true);
    };


    // column definitions for CommonTable
    const columns = [
        {
            headerName: 'Item Details',
            field: 'menu_item_name',
            flex: 1,
            minWidth: 320,
            maxWidth: 350,
            minHeight: 100,
            height: 100,
            renderCell: ({ row }) => {
                const itemName = row?.menu_item_name || row?.name || ''
                const itemNotes = row?.note || row?.notes || ''
                const imageSrc = row?.image
                    ? `${process.env.REACT_APP_API_ROUTE}/files/${row.image}`
                    : null

                return (
                    <Box className='d-flex align-items-center' sx={{ gap: 1, height: '100%' }}>
                        <Box className='d-flex align-items-center' sx={{ height: '100%' }}>
                            {imageSrc ? (
                                <img
                                    src={imageSrc}
                                    alt={itemName}
                                    style={{
                                        width: '60px',
                                        height: '60px',
                                        objectFit: "cover",
                                        borderRadius: '5px',
                                        border: '1px solid #D2D2D2'
                                    }}
                                />
                            ) : (
                                <Box
                                    sx={{
                                        width: '60px',
                                        height: '60px',
                                        borderRadius: '5px',
                                        border: '1px solid #D2D2D2',
                                        backgroundColor: '#F5F5F5',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <CustomTypography
                                        variant="caption"
                                        label={row?.isMiscellaneous ? 'MISC' : ''}
                                        sx={{ fontSize: '10px', fontWeight: 700, color: '#666', mb: 0 }}
                                    />
                                </Box>
                            )}
                        </Box>
                        <Box sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap' }}>
                                <CustomTypography
                                    variant="body2"
                                    label={itemName}
                                    sx={{
                                        fontWeight: 400,
                                        whiteSpace: "normal",
                                        wordBreak: "break-word",
                                        color: theme.palette.drawermenuitem.main,
                                        fontSize: '15px',
                                        mb: 0,
                                    }}
                                />
                                {row?.isMiscellaneous && (
                                    <Chip
                                        label="MISC"
                                        size="small"
                                        sx={{
                                            height: '18px',
                                            borderRadius: '4px',
                                            backgroundColor: '#000',
                                            color: '#fff',
                                            fontWeight: 700,
                                            fontSize: '10px',
                                            letterSpacing: '0.4px',
                                            '& .MuiChip-label': {
                                                px: "6px !important",
                                                py: 0,
                                                lineHeight: 1.2,
                                            },
                                        }}
                                    />
                                )}
                            </Box>
                            {(row?.isMiscellaneous ? row?.notes : row?.note) && (
                                <CustomTypography
                                    variant="caption"
                                    label={`Note: ${row?.isMiscellaneous ? row?.notes : row?.note}`}
                                    sx={{ color: "gray", fontStyle: "italic" }}
                                />
                            )}
                        </Box>
                    </Box>
                )
            }
        },
        // {
        //     headerName: 'Add-Ons',
        //     field: 'add-ons',
        //     flex: 1,
        //     minWidth: 280,
        //     maxWidth: 320,
        //     // minHeight: 100,
        //     // height: 100,
        //     renderCell: ({ row }) => {
        //         if (!row?.orderItemAddons || row.orderItemAddons.length === 0) {
        //             // return <CustomTypography variant="caption" label="-" />;
        //             return "-"
        //         }
        //         return (
        //              <Box component="ul" sx={{ pl: 2, m: 0, alignContent:'center', lineHeight:1, height:'100%' }}>
        //                 {row?.orderItemAddons?.map((ele, idx) => (
        //                 <li key={idx} style={{ listStyleType: "disc" }}>
        //                     <CustomTypography variant="caption" label={ele?.addon_name} sx={{fontSize:'14px', color:theme.palette.drawermenuitem.main, fontWeight:400}}/>
        //                 </li>
        //                 ))}
        //             </Box>
        //         )
        //     }
        // },
        {
            headerName: 'Add-Ons',
            field: 'add-ons',
            flex: 1,
            minWidth: 280,
            maxWidth: 320,
            renderCell: ({ row }) => {
                const addons = row?.orderItemAddons || [];

                if (addons.length === 0) {
                    return (
                        <CustomTypography
                            variant={"body2"}
                            label="-"
                            sx={{ paddingLeft: "10px", fontSize: '15px', fontWeight: 400, color: theme.palette.drawermenuitem.main, display: 'flex', alignItems: 'center', height: '100%' }}
                        />
                    );
                }

                const firstTwo = addons.slice(0, 2);
                const hasMore = addons.length > 2;

                return (
                    <Box component="ul" sx={{ m: 0, alignContent: 'center', lineHeight: 1, height: '100%', paddingLeft: "20px" }}>
                        {firstTwo.map((ele, idx) => (
                            <li key={idx} style={{ listStyleType: "disc" }}>
                                <Typography sx={{ fontSize: "14px", color: "#333" }}>
                                    {ele.addon_name}
                                    {idx === 1 && hasMore ? ",  " : ""}

                                    {idx === 1 && hasMore && (
                                        <span
                                            style={{
                                                textDecoration: "underline",
                                                color: "#1361D5",
                                                cursor: "pointer"
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                openAddonsModal(row);
                                            }}
                                        >
                                            More...
                                        </span>
                                    )}
                                </Typography>
                            </li>
                        ))}
                    </Box>
                );
            }
        },
        {
            headerName: 'Chef',
            field: 'primaryChef',
            flex: 1,
            minWidth: 150,
            maxWidth: 220,
            renderCell: ({ row }) =>
                <CustomTypography
                    variant={"body2"}
                    label={row?.primaryChef?.full_name ? row?.primaryChef?.full_name : "-"}
                    sx={{ paddingLeft: "10px", fontSize: '15px', fontWeight: 400, color: theme.palette.drawermenuitem.main, display: 'flex', alignItems: 'center', height: '100%' }}
                />
        },
        {
            headerName: 'Status',
            field: 'item_status',
            flex: 1,
            minWidth: 200,
            maxWidth: 300,
            renderCell: ({ row }) => {
                const current = row?.item_status;
                let config = { label: 'Completed', color: '#00DD4C', textColor: '#064E3B' }
                if (current === "completed") {
                    config = { label: 'Completed', color: '#00DD4C', textColor: '#064E3B' };
                } else {
                    config = servePanelStatusList.find(s => s.key === current) || config;
                }
                return (
                    <Box className='d-flex align-items-center' sx={{ height: '100%', paddingLeft: "10px" }}>
                        <Typography
                            variant='body2'
                            sx={{
                                color: config?.textColor,
                                fontWeight: '600',
                                fontSize: '13px',
                                lineHeight: '1.5',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            {config?.label}
                        </Typography>
                    </Box>
                );
            }
        },
        {
            headerName: 'Qty',
            field: 'quantity',
            flex: 1,
            minWidth: 60,
            maxWidth: 100,
            minHeight: 100,
            renderCell: ({ row }) => (
                <CustomTypography
                    variant={"body2"}
                    label={row?.quantity}
                    sx={{ paddingLeft: "10px", fontSize: '15px', fontWeight: 400, color: theme.palette.drawermenuitem.main, display: 'flex', alignItems: 'center', height: '100%' }}
                />
            )
        },
        {
            headerName: 'Price/Qty',
            field: 'unit_price',
            flex: 1,
            minWidth: 100,
            maxWidth: 150,
            minHeight: 100,
            // renderCell: ({ row }) => <Box>{row?.unit_price}</Box>
            renderCell: ({ row }) => {
                const basePrice = parseFloat(row?.unit_price || row?.price || 0);
                // Sum of addon prices
                const addonsTotal = row?.orderItemAddons?.reduce(
                    (acc, addon) => acc + parseFloat(addon?.addon_price || 0), 0
                );
                // Final price per quantity (before multiplying with qty)
                const pricePerQty = basePrice + addonsTotal;
                // return <Box>{currencySymbol(userData?.vendor?.currency)}{pricePerQty.toFixed(2)}</Box>;
                return <CustomTypography
                    variant={"body2"}
                    label={`${currencySymbol(userData?.vendor?.currency)}${pricePerQty.toFixed(2)}`}
                    sx={{ paddingLeft: "10px", fontSize: '15px', fontWeight: 400, color: theme.palette.drawermenuitem.main, display: 'flex', alignItems: 'center', height: '100%' }}
                />
            }
        },
        {
            headerName: 'Item Total',
            field: 'total_price',
            flex: 1,
            minWidth: 100,
            maxWidth: 150,
            renderCell: ({ row }) => {
                const basePrice = parseFloat(row?.unit_price || row?.price || 0);
                const addonsTotal = row?.orderItemAddons?.reduce(
                    (acc, addon) => acc + parseFloat(addon?.addon_price || 0),
                    0
                );
                // price per qty (base + addons)
                const pricePerQty = basePrice + addonsTotal;
                // multiply with quantity
                const total = pricePerQty * (row?.quantity || 0);
                return (
                    <CustomTypography
                        variant={"body2"}
                        label={`${currencySymbol(userData?.vendor?.currency)}${total.toFixed(2)}`}
                        sx={{ paddingLeft: "10px", fontSize: '15px', fontWeight: 400, color: theme.palette.drawermenuitem.main, display: 'flex', alignItems: 'center', height: '100%' }}
                    />
                );
            }
        },
    ];

    const itemsTotal = useMemo(() => {
        const rows = orderDetails?.orderItems || [];
        return rows.reduce((sum, row) => {
            const base = parseFloat(row?.unit_price || row?.price || 0);
            const addons = (row?.orderItemAddons || []).reduce(
                (acc, a) => acc + parseFloat(a?.addon_price || 0), 0
            );
            const perQty = base + addons;
            return sum + perQty * (parseFloat(row?.quantity || 0));
        }, 0);
    }, [orderDetails?.orderItems]);

    const handleAddItemtoOrder = () => {
        navigate("/add-item-order", { state: { orderId: orderDetails?.id } });
    }

    // ------- custom overlay + footer (ONLY for this screen) -------
    const EmptyItemsOverlay = () => (
        <Box className='d-flex align-items-center justify-content-center' sx={{ width: '100%', height: '100%' }}>
            <CustomTypography
                variant={"body2"}
                label={"No Food item is added to the order yet."}
                sx={{ fontSize: '16px', color: '#4D4D4D', fontWeight: '400', mb: 0 }}
            />
        </Box>
    );


    const OrderItemsFooter = () => (
        <Box
            sx={{
                width: '100%',
                height: '100%',
                minHeight: '52px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                borderTop: '1px solid #E0E0E0',
                pr: 3,
                py: 1.5,
                boxSizing: 'border-box',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75 }}>
                <Typography
                    component="span"
                    sx={{
                        fontSize: '17px',
                        fontWeight: 600,
                        color: theme.palette.drawermenuitem?.main || '#4D4D4D',
                        lineHeight: 1,
                    }}
                >
                    Order Items Total:
                </Typography>
                <Typography
                    component="span"
                    sx={{
                        fontSize: '20px',
                        fontWeight: 700,
                        color: '#000000',
                        lineHeight: 1,
                    }}
                >
                    {currencySymbol(userData?.vendor?.currency)}{itemsTotal.toFixed(2)}
                </Typography>
            </Box>
        </Box>
    );


    return (
        <>
            <Box className="order-customer-info-container">
                <Box className='d-flex align-items-center justify-content-between'>
                    <CustomTypography
                        variant={"h6"}
                        label={`Items in Order (${orderDetails?.orderItems?.length})`}
                        sx={{ fontSize: '18px', fontWeight: '600', mb: 0 }}
                    />

                    {(() => {
                        const orderSplits = orderDetails?.orderSplits || orderDetails?.order_splits || [];
                        const isFullyPaidOrder = orderDetails?.payment_status === "paid";
                        const isAllSplitsPaid = orderSplits.length > 0 && orderSplits.every(s => s.payment_status === "paid");

                        if (isViewOnly || orderDetails?.order_type === "delivery" || orderDetails?.order_type === "pos" || isFullyPaidOrder || isAllSplitsPaid) {
                            return null;
                        }

                        return (
                            <CustomButton
                                startIcon={<Add />}
                                sx={{ borderRadius: '10px', width: '230px', height: '45px' }}
                                onClick={handleAddItemtoOrder}
                            >
                                Add New Item to Order
                            </CustomButton>
                        );
                    })()}
                </Box>

                <Box sx={{ mt: 2, overflow: 'auto' }}>
                    <CommonDataGrid
                        columns={columns}
                        // rows={orderDetails?.orderItems}
                        rows={orderDetails?.orderItems?.map((r, i) => ({ ...r, id: i }))}
                        isPagination={false}
                        maxHeight={"92px"}
                        minHeight={"40px"}
                        rowHeight={80}
                        renderCustomNoRowsOverlay={EmptyItemsOverlay}
                        renderCustomFooter={OrderItemsFooter}
                    />
                </Box>
            </Box>
            {addonsModalOpen && (
                <AddOnsView
                    open={addonsModalOpen}
                    onClose={() => setAddonsModalOpen(false)}
                    selectedItemAddons={selectedItemAddons}
                    selectedOrderItem={selectedOrderItem}
                />
            )}
        </>
    )
}

export default OrderItemsComponent
